<template>
  <div class="q-pa-md whidth">
    <div class="text-h6 q-mb-sm">Módulos Ativos</div>
    <q-table
      table-header-class="bg-accent text-weight-bold"
      :rows="modulosAtivos"
      :columns="columns"
      flat
      dense
      row-key="name"
      :rows-per-page-options="[0]"
      class="tabela-tamanho-fixo"
    >
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="nome" :props="props">{{ props.row.nome }}</q-td>
          <q-td key="remover" class="text-right">
            <q-btn
              color="white"
              text-color="red"
              round
              flat
              icon="close"
              @click="desativarModulo(props.row.moduloId)"
            />
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script>
import { useStore } from "vuex";

const columns = [
  {
    name: "nome",
    align: "left",
    label: "Nome Módulo",
    field: "NOME MODULO",
  },
  {
    name: "remover",
    align: "right",
    label: "Desativar",
    field: "NOME MODULO",
  },
];

export default {
  name: "DetalheCliente",
  props: ["modulosAtivos", "clienteId"],
  setup(props, { emit }) {
    const store = useStore();

    const desativarModulo = async (moduloId) => {
      try {
        await store.dispatch("office/desvincularModulo", {
          clienteId: props.clienteId,
          moduloId,
        });
        emit("atualizarTabelas");
      } catch (error) {
        console.error(error);
      }
    };

    return { columns, desativarModulo };
  },
};
</script>

<style scoped>
.whidth {
  width: 40%;
}
</style>
